import { lazy, Suspense } from "react";
import { toast } from "sonner";

/**
 * Kept dynamic: sonner rides in its own 36 kB chunk, and a static import here
 * trips rolldown's INEFFECTIVE_DYNAMIC_IMPORT.
 */
const LazyToaster = lazy(() =>
  import("sonner").then((m) => ({ default: m.Toaster })),
);

/** How long a toast stays; the pointer on it or a hidden tab holds it, so each has a close control. */
export const TOAST_MS = 6000;

/** How long a toast with Undo stays: long enough to read it and reach the button, and it can be closed. */
export const UNDO_TOAST_MS = 20_000;

/** Says what was done, with Undo for as long as the attorney needs to reach it. */
export function toastWithUndo(message: string, onUndo: () => void): void {
  toast.success(message, {
    duration: UNDO_TOAST_MS,
    action: { label: "Undo", onClick: onUndo },
  });
}

/**
 * Where a toast appears, one at a time: a stack drew earlier toasts as empty
 * boxes behind the newest. Each root that can be on screen alone mounts one.
 */
export function ToastSurface() {
  return (
    <Suspense fallback={null}>
      <LazyToaster
        position="bottom-right"
        visibleToasts={1}
        duration={TOAST_MS}
        closeButton
      />
    </Suspense>
  );
}
